import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutJobClassLookup extends Layout {
    sourceJobClass: DataSource;
    tableJobClass: Table;
}
